import { render, staticRenderFns } from "./ServiceVersionTip.vue?vue&type=template&id=0947d854&scoped=true"
import script from "./ServiceVersionTip.vue?vue&type=script&lang=js"
export * from "./ServiceVersionTip.vue?vue&type=script&lang=js"
import style0 from "./ServiceVersionTip.vue?vue&type=style&index=0&id=0947d854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947d854",
  null
  
)

export default component.exports